import { AppBar, Toolbar, Typography, Box, Button, Grid, useMediaQuery, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import React from "react";
import {Colours, SamaggiTypography} from "./SamaggiTypography";
import {MatchData} from "../App";

interface NavbarProps {
    isStaff: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ isStaff }) => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));

    return (
        <>
            {isLargeScreen && <AppBar position="static" sx={{ backgroundColor: "#004d40", padding: 1 }}>
                <Toolbar>
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        justifyContent="space-between"
                        flexDirection={"row"} // Stack on small screens
                    >
                        {/* Title - Always at the top on small screens */}
                        <Grid item xs={12} sx={{ textAlign: "center", marginTop: "10px" }}>
                            <SamaggiTypography
                                large
                                colour={Colours.white} sx={{ fontWeight: "bold" }}>
                                SAMAGGI GAMES 2026
                            </SamaggiTypography>
                        </Grid>

                        {/* Navigation Links */}
                        <Grid item xs={12} sm="auto">
                            <Box sx={{ display: "flex", gap: 2}}>
                                <Button color="inherit" component={Link} to="/">
                                    Home
                                </Button>
                                <Button color="inherit" component={Link} to="/ranking">
                                    Ranking
                                </Button>
                                <Button color="inherit" component={Link} to="/staff">
                                    Staff
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>}
            {!isLargeScreen && <AppBar position="static" sx={{ backgroundColor: "#004d40" }}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                    {/* Left Section - Navigation Links */}
                    <Box sx={{ display: "flex", gap: 2 }}>
                        <Button sx={{fontFamily: "\"Montserrat\", \"Roboto\",\"Helvetica\",\"Arial\", sans-serif"}} color="inherit" component={Link} to="/">
                            Home
                        </Button>
                        <Button sx={{fontFamily: "\"Montserrat\", \"Roboto\",\"Helvetica\",\"Arial\", sans-serif"}} color="inherit" component={Link} to="/ranking">
                            Ranking
                        </Button>
                        {isStaff && <Button sx={{fontFamily: "\"Montserrat\", \"Roboto\",\"Helvetica\",\"Arial\", sans-serif"}} color="inherit" component={Link} to="/staff">
                            Staff
                        </Button>}
                    </Box>

                    {/* Center Section - Title */}
                    <SamaggiTypography
                        large
						colour={Colours.white}
                        sx={{
                            fontWeight: "bold",
                            flexGrow: 1,
                            textAlign: "center",
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                        }}
                    >
                        SAMAGGI GAMES 2026
                    </SamaggiTypography>
                </Toolbar>
            </AppBar>}
        </>
    );
}

export default Navbar;